interface ClientConfig {
  UPSTREAM_ENV: string;
  CLIENT_VERSION: string;
}

const config: ClientConfig = (window as any).serverConfig || {};

export default config;
